import React from 'react';
import { Card, CardContent, Typography, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material';
import { ArrowUpward as IncomeIcon, ArrowDownward as ExpenseIcon } from '@mui/icons-material';
// import SavingsChart from './SavingsChart';

const SavingsAccounts = ({ filters }) => {
  // Mock data - replace with real data
  const savingsData = {
    total: 2500000,
    byUser: [
      { user: 'John Doe', balance: 50000 },
      { user: 'Jane Smith', balance: 75000 },
      { user: 'Acme Corp', balance: 1000000 }
    ],
    transactions: [
      { id: 1, user: 'John Doe', type: 'Deposit', amount: 5000, date: '2023-05-01' },
      { id: 2, user: 'Jane Smith', type: 'Withdrawal', amount: 2000, date: '2023-05-03' }
    ]
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Savings Accounts
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
              ${savingsData.total.toLocaleString()}
            </Typography>
            
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  By User
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>User</TableCell>
                        <TableCell align="right">Balance</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {savingsData.byUser.map((user) => (
                        <TableRow key={user.user}>
                          <TableCell>{user.user}</TableCell>
                          <TableCell align="right">${user.balance.toLocaleString()}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  Recent Activity
                </Typography>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>User</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell align="right">Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {savingsData.transactions.map((txn) => (
                        <TableRow key={txn.id}>
                          <TableCell>{txn.date}</TableCell>
                          <TableCell>{txn.user}</TableCell>
                          <TableCell>
                            <Chip 
                              label={txn.type} 
                              size="small" 
                              color={txn.type === 'Deposit' ? 'success' : 'error'}
                              icon={txn.type === 'Deposit' ? <IncomeIcon /> : <ExpenseIcon />}
                            />
                          </TableCell>
                          <TableCell align="right">${txn.amount.toLocaleString()}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SavingsAccounts;